module.exports = __webpack_public_path__ + "img/eca.152afe87.svg";